import React from 'react'
import '../components_css/Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <div className='first_circle'></div>
            <div className='second_circle'></div>
            <div className='third_circle'></div>
        </div>
    )
}

export default Footer
